var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#DCEBC9",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#565C6A",
    d: "M17.2334 17.1126c0 .5925-.1458 1.1029-.4375 1.5313-.2871.4284-.7018.7565-1.2441.9844-.5378.2278-1.1804.3418-1.9278.3418-.3646 0-.7132-.0206-1.0459-.0616-.3327-.041-.6471-.1002-.9433-.1777-.2917-.082-.5583-.18-.7998-.2939v-1.545c.4056.1778.859.3395 1.3603.4854.5013.1413 1.0117.2119 1.5313.2119.4238 0 .7747-.0547 1.0527-.1641.2825-.1139.4922-.2734.6289-.4785.1367-.2096.2051-.4534.2051-.7314 0-.2963-.0798-.5469-.2393-.752-.1595-.2051-.401-.3919-.7246-.5605-.319-.1732-.72-.3578-1.2031-.5537-.3281-.1322-.6426-.2826-.9434-.4512-.2962-.1686-.5605-.3669-.7929-.5947-.2325-.2279-.417-.4968-.5538-.8067-.1321-.3144-.1982-.6836-.1982-1.1074 0-.5651.1344-1.0482.4033-1.4492.2735-.4011.6563-.7087 1.1485-.9229.4967-.21416 1.0755-.32126 1.7363-.32126.5241 0 1.0163.05469 1.4766.16406.4648.10938.9205.2643 1.3671.4648l-.5195 1.3194c-.4101-.1686-.8089-.3031-1.1963-.4033-.3828-.1003-.7747-.1504-1.1758-.1504-.3463 0-.6403.0524-.8818.1572-.2415.1048-.4261.2529-.5537.4443-.1231.1869-.1846.4102-.1846.67 0 .2916.0707.5377.2119.7382.1459.196.3692.376.67.5401.3053.164.6972.3463 1.1757.5469.5515.2278 1.0186.4671 1.4014.7177.3874.2507.6836.5515.8887.9024.2051.3463.3076.7815.3076 1.3056Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderground);
export default __webpack_public_path__ + "static/media/underground.031a1ff7516671c817f3b3bd826383b8.svg";
export { ForwardRef as ReactComponent };